import {
  JPEG_FORMAT_KEY,
  PNG_FORMAT_KEY,
  SVG_FORMAT_KEYS,
  JPG_FORMAT_KEY,
} from "@stadium/constants/logo";

export const UPLOAD_ACCEPTABLE_LOGO_FORMATS = [
  ...SVG_FORMAT_KEYS,
  PNG_FORMAT_KEY,
  JPEG_FORMAT_KEY,
  JPG_FORMAT_KEY,
];

export const LOGO_IMAGE_FILE_SIZE_IN_BYTES = 5 * 1024 * 1024;

const uploadFromDeviceTab = {
  key: "upload_from_device",
  label: "Upload from device",
  title: "Add your logo from your device",
  authenticationRequired: false,
};

const previousUploadsTab = {
  key: "previous_uploads",
  label: "Previous uploads",
  title: "Add your logo from previous uploads",
  authenticationRequired: true,
};

const assetLibraryTab = {
  key: "asset_library",
  label: "Asset Library",
  title: "Choose a logo from your asset library",
  authenticationRequired: true,
};

export const LOGO_STATUS_TABS = {
  asset_library: assetLibraryTab,
  upload_from_device: uploadFromDeviceTab,
  previous_uploads: previousUploadsTab,
};

export const ADD_LOGO_STATUS_TABS = {
  asset_library: assetLibraryTab,
  upload_from_device: uploadFromDeviceTab,
  previous_uploads: previousUploadsTab,
};

export const MAX_LOGOS_PER_PAGE = 20;

export const ASSET_KINDS = {
  logo: "logo",
  designGuidelines: "design_guidelines",
};

export const SWAG_LOGO_FILE_DETAILS = {
  fileSizeInBytes: 25 * 1024 * 1024,
  fileSizeInMB: 25,
};

export const DEFAULT_FORM_VALUES = {
  decorationMethod: "",
  logoPlacement: "",
  notes: "",
};
